import { Box, H1 } from '@betterment/samba-react';

import { AdditionalBenefitsCard } from './additional-benefits-card/AdditionalBenefitsCard';
import { PayrollCard } from './payroll-card/PayrollCard';
import { PlanInsights } from './plan-insights/PlanInsights';
import { ResourcesCard } from './resources-card/ResourcesCard';
import { HomeSupportCard } from './support-card/HomeSupportCard';

import { ApplicationLayout } from '../layout/ApplicationLayout';
import { TasksCard } from '../tasks/tasks-card/TasksCard';

export const HomePage = () => {
  return (
    <ApplicationLayout pageTitle="Reports">
      <ApplicationLayout.Header>
        <H1 variant="pageTitle">Dashboard home</H1>
      </ApplicationLayout.Header>
      <ApplicationLayout.Content>
        <Box
          css={{
            display: 'grid',
            gridTemplateColumns: { base: '1fr', md: '2fr 1fr' },
            gap: 'space.300',
            alignItems: 'start',
          }}
        >
          {/* Left column */}
          <Box
            css={{
              display: { base: 'contents', md: 'flex' },
              flexDirection: 'column',
              gap: 'space.300',
            }}
          >
            <Box css={{ order: { base: 1 } }}>
              <TasksCard />
            </Box>

            <Box css={{ order: { base: 2 } }}>
              <PlanInsights />
            </Box>

            <Box css={{ order: { base: 6 } }}>
              <ResourcesCard />
            </Box>
          </Box>

          {/* Right column */}
          <Box
            css={{
              display: { base: 'contents', md: 'flex' },
              flexDirection: 'column',
              gap: 'space.300',
            }}
          >
            {/* CTA buttons placeholder — hidden on small screens */}
            <Box css={{ display: { base: 'none', md: 'block' } }}>CTAs</Box>

            <Box css={{ order: { base: 3 } }}>
              <PayrollCard />
            </Box>

            <HomeSupportCard />

            <Box css={{ order: { base: 5 } }}>
              <AdditionalBenefitsCard />
            </Box>
          </Box>
        </Box>
      </ApplicationLayout.Content>
      <ApplicationLayout.Footer />
    </ApplicationLayout>
  );
};
